import { RootState } from '@mindfulchefuk/types/store'
import { createSelector } from '@reduxjs/toolkit'

import { useGroupRecipesByQuantity } from '@mindfulchefuk/features/Onboarding/hooks/useGroupRecipesByQuantity'

export const getRecipeById = (id: string) =>
  createSelector(
    [
      (state: RootState) => state.recipes.allRecipes,
      (state: RootState) => state.basket.items,
    ],
    (allRecipes, onboardingRecipes) => {
      const recipesGroupedByQuantity =
        useGroupRecipesByQuantity(onboardingRecipes)

      const basketRecipe = recipesGroupedByQuantity.find(
        (recipe) => recipe.id === id
      )

      const recipe = allRecipes.find((r) => r.id === id)

      if (!recipe) return undefined

      return {
        ...recipe,
        quantity: basketRecipe ? basketRecipe.quantity : 0,
      }
    }
  )
